import React from 'react';
import { Users } from 'lucide-react';
import ApplicationsList from './ApplicationsList';
import FirebaseApplicationsList from './FirebaseApplicationsList';
import { useJobApplications } from '../../hooks/useJobApplications';

interface JobApplicationsSectionProps {
  jobId: string;
}

export default function JobApplicationsSection({ jobId }: JobApplicationsSectionProps) {
  const { applications, loading, error, refreshApplications } = useJobApplications(jobId);
  
  // Determine if this is a Supabase or Firebase job
  const isSupabaseJob = jobId.includes('-') && jobId.length > 20;

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="flex items-center space-x-2 mb-4">
          <Users className="h-5 w-5 text-green-600" />
          <h2 className="text-lg font-semibold">Applications</h2>
        </div>
        <div className="animate-spin h-6 w-6 border-4 border-green-500 border-t-transparent rounded-full mx-auto"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="flex items-center space-x-2 mb-4">
          <Users className="h-5 w-5 text-green-600" />
          <h2 className="text-lg font-semibold">Applications</h2>
        </div>
        <div className="bg-red-50 border border-red-200 rounded-md p-3 text-red-800">
          <p>Error loading applications: {error.message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="flex items-center space-x-2 mb-4">
        <Users className="h-5 w-5 text-green-600" />
        <h2 className="text-lg font-semibold">
          Applications ({applications.length})
          {!isSupabaseJob && (
            <span className="text-sm font-normal text-gray-500 ml-2">(Legacy)</span>
          )}
        </h2>
      </div>
      
      {isSupabaseJob ? (
        <ApplicationsList 
          applications={applications}
          onStatusUpdate={refreshApplications}
        />
      ) : (
        <FirebaseApplicationsList applications={applications} />
      )}
    </div>
  );
}